import React, { useContext, useState, useEffect } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import {
    Flex,
    Container,
    MaestroThemeProvider,
    defaultTheme,
    Button,
    Logo,
    NotificationProvider,
    LeaveOutlined,
} from '@landr/maestro';
import { Trans } from '@lingui/macro';
import {
    AuthenticationContext,
    AuthenticationProvider,
} from 'contexts/AuthenticationContext';
import { CONFIG } from 'utils/config';
import authenticationService from 'utils/authentication';
import Auth0HandleRedirectComponent from './utils/Auth0';
import { NewPack } from './pages';
import { initialStore } from './constants';

export const StoreContext = React.createContext(initialStore);

const SamplesIngestionAdmin: React.FC = () => {
    // STATE
    const [genres, setGenres] = useState(initialStore.genres);

    // Fetch genres and subgenres
    useEffect(() => {
        async function fetchGenres(): Promise<void> {
            const response = await fetch(
                `${CONFIG.MARKETPLACE_API_URL}/v1/genres`,
            );
            const genres = await response.json();
            setGenres(genres);
        }
        fetchGenres();
    }, []);

    return (
        <NotificationProvider>
            <StoreContext.Provider
                value={{
                    genres,
                }}
            >
                <MaestroThemeProvider theme={defaultTheme} mode={'dark'}>
                    <Container my={'xxl'} px={'md'} size="lg">
                        <AppNavBar />
                        <Switch>
                            <Route exact path="/" component={NewPack} />
                        </Switch>
                    </Container>
                </MaestroThemeProvider>
            </StoreContext.Provider>
        </NotificationProvider>
    );
};

const AppNavBar: React.FC = () => {
    // CONTEXT
    const { isAuthenticated, logout } = useContext(AuthenticationContext);

    return (
        <Flex
            marginBottom="130px"
            width="100%"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
        >
            <Flex>
                <Logo variant={'brand'} />
            </Flex>
            <Flex>
                {isAuthenticated && (
                    <Button
                        onClick={(): void => logout()}
                        icon={LeaveOutlined}
                        isRounded
                        variant="ghost"
                    >
                        <Trans>Logout</Trans>
                    </Button>
                )}
                {!isAuthenticated && (
                    <Button
                        onClick={void authenticationService.login}
                        icon={LeaveOutlined}
                        isRounded
                        variant="ghost"
                    >
                        <Trans>Login</Trans>
                    </Button>
                )}
            </Flex>
        </Flex>
    );
};

const App = (): JSX.Element => {
    return (
        <Switch>
            <Route
                exact
                path="/callback"
                component={Auth0HandleRedirectComponent}
            />
            <AuthenticationProvider>
                <Route path="/" component={SamplesIngestionAdmin} />
            </AuthenticationProvider>
        </Switch>
    );
};

export default withRouter(App);
